import requests from "@/utils/requests_self";
import JsBridgeNew from "@/utils/jsbridgeNew";
import appService from "@/utils/appService";
import {queryDefCode} from "@/api/projectManager_self";

class Service {

  // 活动码
  static activityCode = 'matchGame';
  static activityCode2 = 'GulandMatchGame'; // 宝石乐园

  static mock = false
  static mockData = [
    {
      "id": 29,
      "clientId": "8892639a4d6546e28cd95f38a4ebffc8",
      "roundNumber": 0,
      "fruits": "{\"WATERMELON\":1,\"BLUEBERRIES\":0,\"PEACHES\":1,\"ORANGES\":0,\"LEMONS\":0,\"GREEN_APPLES\":0,\"TOMATOES\":1,\"GARLIC\":0,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":1}",
      "sendFruits": "{\"WATERMELON\":5,\"BLUEBERRIES\":4,\"PEACHES\":1,\"ORANGES\":1,\"LEMONS\":1,\"TOMATOES\":1,\"GARLIC\":1,\"PURPLE_RADISH\":2,\"GREEN_RADISH\":4}",
      "endFruits": "{\"WATERMELON\":6,\"BLUEBERRIES\":4,\"PEACHES\":2,\"ORANGES\":1,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":2,\"GARLIC\":1,\"PURPLE_RADISH\":3,\"GREEN_RADISH\":5}",
      "points": 0,
      "stamina": 0,
      "createTime": "2025-04-19 10:16:21",
      "updateTime": "2025-04-19 10:16:21",
      "orderId": "c4aa108da13c3c9e17c03fc19365e6f6"
    },
    {
      "id": 30,
      "clientId": "8892639a4d6546e28cd95f38a4ebffc8",
      "roundNumber": 1,
      "fruits": "{\"WATERMELON\":6,\"BLUEBERRIES\":4,\"PEACHES\":2,\"ORANGES\":1,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":2,\"GARLIC\":1,\"PURPLE_RADISH\":3,\"GREEN_RADISH\":5}",
      "sendFruits": "{\"WATERMELON\":3,\"BLUEBERRIES\":2,\"PEACHES\":1,\"GARLIC\":1,\"PURPLE_RADISH\":2,\"GREEN_RADISH\":1}",
      "endFruits": "{\"WATERMELON\":0,\"BLUEBERRIES\":0,\"PEACHES\":0,\"ORANGES\":1,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":1,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":1}",
      "points": 206,
      "stamina": 10,
      "createTime": "2025-04-19 10:16:21",
      "updateTime": "2025-04-19 10:16:21",
      "orderId": "c4aa108da13c3c9e17c03fc19365e6f6"
    },
    {
      "id": 31,
      "clientId": "8892639a4d6546e28cd95f38a4ebffc8",
      "roundNumber": 2,
      "fruits": "{\"WATERMELON\":3,\"BLUEBERRIES\":2,\"PEACHES\":1,\"ORANGES\":1,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":2,\"PURPLE_RADISH\":3,\"GREEN_RADISH\":2}",
      "sendFruits": "{\"WATERMELON\":1,\"PEACHES\":1,\"ORANGES\":1,\"GREEN_RADISH\":2}",
      "endFruits": "{\"WATERMELON\":1,\"BLUEBERRIES\":0,\"PEACHES\":1,\"ORANGES\":1,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":0,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":0}",
      "points": 132,
      "stamina": 5,
      "createTime": "2025-04-19 10:16:21",
      "updateTime": "2025-04-19 10:16:21",
      "orderId": "c4aa108da13c3c9e17c03fc19365e6f6"
    },
    {
      "id": 32,
      "clientId": "8892639a4d6546e28cd95f38a4ebffc8",
      "roundNumber": 3,
      "fruits": "{\"WATERMELON\":2,\"BLUEBERRIES\":0,\"PEACHES\":2,\"ORANGES\":2,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":0,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":2}",
      "sendFruits": "{\"WATERMELON\":2,\"BLUEBERRIES\":1,\"GARLIC\":1}",
      "endFruits": "{\"WATERMELON\":0,\"BLUEBERRIES\":0,\"PEACHES\":0,\"ORANGES\":0,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":0,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":0}",
      "points": 82,
      "stamina": 4,
      "createTime": "2025-04-19 10:16:21",
      "updateTime": "2025-04-19 10:16:21",
      "orderId": "c4aa108da13c3c9e17c03fc19365e6f6"
    },
    {
      "id": 33,
      "clientId": "8892639a4d6546e28cd95f38a4ebffc8",
      "roundNumber": 4,
      "fruits": "{\"WATERMELON\":2,\"BLUEBERRIES\":1,\"PEACHES\":0,\"ORANGES\":0,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":1,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":0}",
      "sendFruits": "{\"WATERMELON\":1}",
      "endFruits": "{\"WATERMELON\":0,\"BLUEBERRIES\":1,\"PEACHES\":0,\"ORANGES\":0,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":1,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":0}",
      "points": 2,
      "stamina": 1,
      "createTime": "2025-04-19 10:16:21",
      "updateTime": "2025-04-19 10:16:21",
      "orderId": "c4aa108da13c3c9e17c03fc19365e6f6"
    },
    {
      "id": 34,
      "clientId": "8892639a4d6546e28cd95f38a4ebffc8",
      "roundNumber": 5,
      "fruits": "{\"WATERMELON\":1,\"BLUEBERRIES\":1,\"PEACHES\":0,\"ORANGES\":0,\"LEMONS\":1,\"GREEN_APPLES\":0,\"TOMATOES\":0,\"GARLIC\":1,\"PURPLE_RADISH\":1,\"GREEN_RADISH\":0}",
      "sendFruits": "null",
      "endFruits": "null",
      "points": 0,
      "stamina": 0,
      "createTime": "2025-04-19 10:16:21",
      "updateTime": "2025-04-19 10:16:21",
      "orderId": "c4aa108da13c3c9e17c03fc19365e6f6"
    }
  ]

  /**
   * 获取初始化数据
   * @return {Promise<AxiosResponse<any>>}
   */
  static initDateWithNoActive = async (type) => {
    return await requests.post(`/customer/game/init/${type}`);
  };
  /**
   * 获取购买后的水果
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  static getGameDataService = async (params = {}) => {
    // const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const param = {
      // clientId: userInfo.clientId,
      ...params,
    }
    if(Service.mock){
      return {
        "code": "000000",
        "data": Service.mockData,
        "msg": null
      }
    }
    return await requests.post('/customer/game/game-record',JSON.stringify(param))
  }
  /**
   * @description 获取用户信息，是否实名
   * @returns {ID: 存在则实名}
   */
  static getUserCertificateStatus = async () => {
    if (window.JsBridge.hasWebViewBridge()) {
      const res = await window.JsBridge.getDetailCurrentUserInfo()
      return res;
    } else {
      return {};
    }
  }
  /**
   * 获取购买记录
   * @param params
   * @return {Promise<AxiosResponse<any>>}
   */
  static getBuyPowerList = async (params = {}) => {
    // const userInfo = await JsBridgeNew.getCurrentUserInfo();
    return await requests.post('/customer/game/matchGameOrderList',JSON.stringify({...params}))
  }
  /**
   * @description 查询兑换记录
   * @param {activityCode}
   * @code 101329
   */

  static getExchangeList = async (params={})=> {
    const code = '101329';
    const userInfo = await JsBridgeNew.getCurrentUserInfo();
    const param = {
      activityCode: params?.fromGems ? Service.activityCode2 : Service.activityCode,
      userCode: userInfo?.loginName,
      // ...params,
    }
    const res = await appService(code, param)
    return res;
  }
  /**
   * @description 获取活动规则
   * @param {*} params
   * @returns
   */
  static getActivityRules = async ()=> {
    return await queryDefCode({codeType: 'activityRule', code: Service.activityCode});
  }
  static getMyWalletAddressService = async (params = {}) => {
    return await requests.post('/customer/blockchain/v1/getMyWalletAddress')
  }
}
export default Service